module.exports = __webpack_public_path__ + "static/media/icon_tv-show_blue.390050e8.svg";